<template>
<div>
    <slot></slot>
</div>
</template>

<script>
export default {
  name: "Mainnavigation",

  mounted() {
    this.navbarToggler = document.querySelector("div.sw-menu-icon");
    if (this.navbarToggler) {
      // Mouse click handler
      this.navbarToggler.onclick = (e) => {
        e.preventDefault();
        this.toggleMenu();
      }

      // Keyboard handler for accessibility
      this.navbarToggler.onkeydown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.toggleMenu();
        }
      }

      // Add ARIA attributes
      this.navbarToggler.setAttribute('role', 'button');
      this.navbarToggler.setAttribute('tabindex', '0');
      this.navbarToggler.setAttribute('aria-expanded', 'false');
      this.navbarToggler.setAttribute('aria-label', 'Hauptmenü öffnen/schließen');
    }
  },

  methods: {
    isDropdownDisabled() {
      return false;
    },

    toggleMenu() {
      let elm = document.querySelector(this.navbarToggler.getAttribute("data-collapse"));
      const isExpanded = elm.classList.contains("show");

      elm.classList.toggle("show");

      // Update ARIA attributes
      this.navbarToggler.setAttribute('aria-expanded', !isExpanded);

      // Focus management
      if (!isExpanded) {
        // Focus first focusable element in menu when opening
        const firstFocusable = elm.querySelector('a, button, [tabindex]:not([tabindex="-1"])');
        if (firstFocusable) {
          firstFocusable.focus();
        }
      }
    }
  }
};
</script>
